import {
  ApiResponse,
  ResponseStatus,
  ResponseType,
} from '../../../../shared/infrastructure/types/api/api-types';

interface IHttpClient {
  get<RESP, ERR = unknown>(url: Url, config?: HttpRequestConfig): Promise<ApiResponse<RESP, ERR>>;

  post<REQ, RESP, ERR = unknown>(
    url: Url,
    data?: REQ,
    config?: HttpRequestConfig,
  ): Promise<ApiResponse<RESP, ERR>>;

  put<REQ, RESP, ERR = unknown>(
    url: Url,
    data?: REQ,
    config?: HttpRequestConfig,
  ): Promise<ApiResponse<RESP, ERR>>;

  delete<RESP, REQ = unknown, ERR = unknown>(
    url: Url,
    data?: REQ,
    config?: HttpRequestConfig,
  ): Promise<ApiResponse<RESP, ERR>>;
}

type RealTimeMessage = string | ArrayBufferLike | Blob | ArrayBufferView;

interface IRealtimeClient {
  openConnection(
    url?: WsUrl,
    onOpen?: PureCallback,
    onClose?: PureCallback,
    onError?: PureCallback,
  ): Promise<boolean>;
  closeConnection(): void;
  isStarted(): boolean;
  send<MessageType extends RealTimeMessage>(message: MessageType): void;
  setHandler<ResponseType>(handler: (response: ResponseType) => void);
  state: RealtimeClientState | undefined;
}

enum RealtimeClientState {
  CONNECTING,
  OPEN,
  CLOSING,
  CLOSED,
}

enum ApiClientMode {
  SHARD,
  SUPREME,
  PHONE_BUS,
  ORIGIN,
  PRODUCT_ORIGIN,
  CHATBOT_ASSISTANT,
}

interface IApiClient {
  httpClient: IHttpClient;
  get<RESP, PARAMS, ERR = unknown>(
    path: UrlPath,
    params?: PARAMS,
    mode?: ApiClientMode,
    customHeaders?: Record<string, string>,
  ): Promise<ApiResponse<RESP, ERR>>;

  post<REQ, RESP, ERR = unknown>(
    path: UrlPath,
    data?: REQ,
    mode?: ApiClientMode,
    contentType?: ContentType,
    customHeaders?: Record<string, string>,
    queryParams?: object,
  ): Promise<ApiResponse<RESP, ERR>>;

  put<REQ, RESP, ERR = unknown>(
    path: UrlPath,
    data?: REQ,
    mode?: ApiClientMode,
  ): Promise<ApiResponse<RESP, ERR>>;

  delete<RESP, REQ = unknown, ERR = unknown>(
    path: UrlPath,
    data?: REQ,
    mode?: ApiClientMode,
  ): Promise<ApiResponse<RESP, ERR>>;
}

interface Authorization {
  accessToken: AccessTokenBody;
}

interface HttpRequestConfig {
  headers?: HttpRequestHeaders;
  params?: unknown;
  responseType?: 'blob';
}

type ContentType = 'multipart/form-data' | 'application/json';

type HttpRequestHeaders = Record<string, string | number | boolean>;

export {
  type RealTimeMessage,
  RealtimeClientState,
  type IRealtimeClient,
  type ContentType,
  type IHttpClient,
  type Authorization,
  type HttpRequestConfig,
  type IApiClient,
  ApiClientMode,
};
